import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchUser } from '../../redux/auth/actions/auth';
import { useParams } from 'react-router-dom';
// Css
import './ActivateView.css';

const ActivateView = ({ dispatch, auth }) => {
    const [password, setPassword] = useState('');
    const [newPwd, setNewPwd] = useState('');
    const [confirmNewPwd, setConfirmNewPwd] = useState('');
    const [passwordValidation, setPasswordValidation] = useState(true);
    const [passwordValidationMessage, setPasswordValidationMessage] = useState(null);
    const { emailId } = useParams();
    const [email, setEmail] = useState(emailId);

    const handleSignIn = (e) => {
        e.preventDefault();
        if (validateNewPassword()) {
            dispatch(fetchUser({ email, password, newPwd }));
        }
    };

    const validateNewPassword = () => {
        if (newPwd !== confirmNewPwd) {
            setPasswordValidation(false);
            setPasswordValidationMessage("New password and confirm password both do not match.");
            return false;
        }

        if (newPwd.length < 12) {
            setPasswordValidation(false);
            setPasswordValidationMessage("New password must be at least 12 characters or more in length.");
            return false;
        }

        if (!/\d+/.test(newPwd)) {
            setPasswordValidation(false);
            setPasswordValidationMessage("New password must contain at least one number.");
            return false;
        }

        if (!/[a-z]/.test(newPwd)) {
            setPasswordValidation(false);
            setPasswordValidationMessage("New password must contain at least one lowercase letter.");
            return false;
        }

        if (!/[A-Z]/.test(newPwd)) {
            setPasswordValidation(false);
            setPasswordValidationMessage("New password must contain at least one uppercase letter.");
            return false;
        }

        if (!/\W/.test(newPwd)) {
            setPasswordValidation(false);
            setPasswordValidationMessage("New password must contain at least one special character.");
            return false;
        }

        return true;
    };

    return (
        <div id="activate-view">
            <div className="loginLogo"></div>
            <div className="activateContainer">
                <div className="titleContainer">
                    <h2>Activate your account</h2>
                    <p>Enter the password provided and a new password to activate your account. All passwords must:</p>
                    <ul>
                        <li>be a minimum of 12 characters</li>
                        <li>Include at least one number, special character, uppercase and lowercase letters.</li>
                    </ul>
                    {auth.error && <p className="error">{auth.error}</p>}
                    {!passwordValidation && <p className="error">{passwordValidationMessage}</p>}
                </div>
                <div><br /></div>
                <div className="formContainer">
                    <Form onSubmit={handleSignIn}>
                        <div className="padding">
                            <Form.Group controlId="formBasicText">
                                <Form.Control
                                    type="text"
                                    placeholder="Email address"
                                    className="username"
                                    readOnly
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                <Form.Control.Feedback />
                            </Form.Group>
                            <Form.Group controlId="formPassword">
                                <Form.Control
                                    type="password"
                                    placeholder="Temporary Password"
                                    autoComplete="off"
                                    className="password"
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                                <Form.Control.Feedback />
                            </Form.Group>
                            <Form.Group controlId="formPassword">
                                <Form.Control
                                    type="password"
                                    placeholder="New Password"
                                    autoComplete="off"
                                    className="password"
                                    onChange={(e) => setNewPwd(e.target.value)}
                                />
                                <Form.Control.Feedback />
                            </Form.Group>
                            <Form.Group controlId="formPassword">
                                <Form.Control
                                    type="password"
                                    placeholder="Confirm New Password"
                                    autoComplete="off"
                                    className="password"
                                    onChange={(e) => setConfirmNewPwd(e.target.value)}
                                />
                                <Form.Control.Feedback />
                            </Form.Group>
                        </div>
                        <Form.Group controlId="formPassword">
                            <Button type="submit" bsStyle="primary" className="activate-button">Submit</Button>
                        </Form.Group>
                    </Form>
                </div>
            </div>
        </div>
    );
};

ActivateView.propTypes = {
    dispatch: PropTypes.func.isRequired,
    auth: PropTypes.object
};

const select = ({ auth }) => ({ auth });

export default connect(select)(ActivateView);
